import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Subject } from 'rxjs';

export const onClickLoginSub = new Subject<any>();

@Component({
  selector: 'x-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  encapsulation: ViewEncapsulation.None
})


export class ToastComponent implements OnInit {

  constructor(public messageService: MessageService) { }

  ngOnInit(): void {
  }

  onLoginClick() {
    this.messageService.clear('toast-login'); 
    onClickLoginSub.next(true);
  }

  
}

